import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightCurvedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18 14",
	style: { enableBackground: "new 0 0 18 14" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.arrow-right-angled-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "arrow-right-angled-st0",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5937 0.292893C11.9842 -0.0976311 12.6174 -0.0976311 13.0079 0.292893L16.8079 4.09289C17.1984 4.48342 17.1984 5.11658 16.8079 5.50711L13.0079 9.30711C12.6174 9.69763 11.9842 9.69763 11.5937 9.30711C11.2032 8.91658 11.2032 8.28342 11.5937 7.89289L14.6866 4.8L11.5937 1.70711C11.2032 1.31658 11.2032 0.683417 11.5937 0.292893Z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "arrow-right-angled-st0",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 5.80078C6.76823 5.80078 5.12171 6.49328 3.90711 7.70789C2.6925 8.92249 2 10.569 2 12.3008C2 12.8531 1.55228 13.3008 1 13.3008C0.447715 13.3008 0 12.8531 0 12.3008C0 10.0326 0.907497 7.87907 2.49289 6.29367C4.07829 4.70828 6.23177 3.80078 8.5 3.80078H16C16.5523 3.80078 17 4.2485 17 4.80078C17 5.35307 16.5523 5.80078 16 5.80078H8.5Z"
	})] }) }) }) })]
});
export default SvgArrowRightCurvedIcon;
